<template>
  <div class="main">
    <div class="swipe">
      <img src="http://123.56.170.62:9999/static/bg/banner5.png" alt />
    </div>
    <div class="program">
      <div class="showSomeProgram">
        <div class="pheader">
          <i class="el-icon-arrow-left"></i>
          <span @click="ret">返回列表</span>
        </div>
        <div class="pLine"></div>
        <div class="video" v-if="newsData.journalism">
          <!-- <canvas id="mycanvas" width="800" height="600" ref="canvas"></canvas> -->
          <video-player
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            @pause="pausePlay($event)"
            :options="playerOptions"
          ></video-player>
        </div>
        <div class="pabs">
          <h2>{{ newsData.name }}</h2>
          <h4>
            <span>{{ newsData.putime }}</span>
            <span>浏览量 : {{ newsData.countpublic }}</span>
          </h4>
          <div class="pabsContent" v-html="newsData.content"></div>
        </div>
        <div class="rebtn">
          <el-button @click="ret" type="primary">返回列表</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsDetail } from "@/api/news.js"
import "../../../public/css/reset.css"
import Bus from "@/utils/bus.js"
import { BASE_URL } from "@/utils/base.js"
import { videoPlayer } from "vue-video-player"
export default {
  name: "Home",
  data() {
    return {
      url: "",
      newsData: {},
      playerOptions: {
        //播放速度
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        //如果true,浏览器准备好时开始回放。
        autoplay: false,
        // 默认情况下将会消除任何音频。
        muted: false,
        // 导致视频一结束就重新开始。
        loop: false,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: "auto",
        language: "zh-CN",
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: "16:9",
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        sources: [
          {
            //类型
            type: "video/mp4",
            //url地址
            src: "",
          },
        ],
        //你的封面地址
        poster: "",
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          //全屏按钮
          fullscreenToggle: true,
        },
      },
    }
  },
  mounted() {
    window.scrollTo({
      top: 0,
    })
    this.getData()
    this.$nextTick(function() {
      if (this.newsData.vypublic == "活动展示") {
        Bus.$emit("getCurrent", "news")
      } else {
        Bus.$emit("getCurrent", "news")
      }
    })

    // this.$nextTick(()=>{
    //  this.$refs.myVideo.src = "../../assets/demo.mp4";
    // })
  },
  methods: {
    // 获取数据
    async getData() {
      let news = new FormData()
      news.append("id", this.$route.params.id)
      let data = await getNewsDetail(news)
      this.newsData = data
      if (this.newsData.journalism) {
        this.newsData.journalism = BASE_URL + this.newsData.journalism
        this.playerOptions.sources[0].src = this.newsData.journalism
      }
    },
    pausePlay(player) {
      //关闭弹窗-停止播放
      this.player.pause()
    },
    // 返回上一页
    ret() {
      this.$router.go(-1)
    },
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player
    },
  },
  components: { videoPlayer },
}
</script>
<style lang="less" scoped>
.main {
  width: 100%;
  .swipe {
    width: 100%;
    img {
      width: 100%;
      height: 400px;
    }
  }
  .program {
    padding-bottom: 42px;
    width: 100%;
    background-color: #fff;
    .showSomeProgram {
      width: 854px;
      margin: 40px auto;
      .pheader {
        text-align: left;
        margin: 40px 15px 20px;
        font-size: 16px;
        i {
          color: #ff4040;
          margin-right: 10px;
        }
        span {
          color: #000;
          cursor: pointer;
        }
      }
      .pLine {
        width: 100%;
        height: 2px;
        margin: 0;
        background-color: #f5f5f5;
      }
      .video {
        margin: 30px auto 0;
        width: 480px;
        height: 270px;
        // video::-webkit-media-controls-fullscreen-button {
        //   display: none;
        // }
      }
      .pabs {
        width: 620px;
        margin: 60px auto 0;
        display: flex;
        flex-direction: column;
        font-size: 14px;
        color: #000;
        h2 {
          font-size: 24px;
          color: #000;
          line-height: 1.3;
          text-align: center;
          margin-bottom: 30px;
        }
        .pabsContent {
          line-height: 1.5;
        }
        h4 {
          display: flex;
          margin-bottom: 20px;
          justify-content: flex-end;
          span {
            margin-right: 10px;
          }
        }
      }
      .rebtn {
        text-align: center;
        margin-top: 60px;
      }
    }
  }
}
</style>
